var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9082 11.1834L28.8156 13.0719C29.0613 13.3158 29.0613 13.6809 28.8156 13.9253L23.0924 19.5918C23.0312 19.6531 22.9693 19.7137 22.9081 19.7137H22.8468L19.9543 20.6883C19.8931 20.749 19.8312 20.749 19.77 20.749C19.5856 20.749 19.4625 20.6884 19.3393 20.5665C19.2162 20.4445 19.155 20.2007 19.2162 19.9569L20.2006 17.0931V17.0324C20.2317 17.002 20.2471 16.9713 20.2626 16.9407C20.2779 16.9104 20.2932 16.8801 20.3237 16.8499L26.0469 11.1834C26.2925 10.9395 26.6619 10.9395 26.9082 11.1834ZM27.2157 13.8028L27.5232 13.4983L26.4769 12.4624L26.1694 12.7669L27.2157 13.8028ZM22.6613 18.3115L21.6156 17.2762L25.3081 13.6203L26.3544 14.6562L22.6613 18.3115ZM21 18.4334L20.7537 19.1648L21.4925 18.921L21 18.4334Z",
    fill: "#4C4C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9232 19.5305C25.5538 19.5305 25.3076 19.7743 25.3076 20.14V24.4049C25.3076 25.0751 24.7538 25.6233 24.077 25.6233H15.4613C14.7844 25.6233 14.2307 25.0751 14.2307 24.4049V15.8745C14.2307 15.2043 14.7844 14.6561 15.4613 14.6561H19.7688C20.1382 14.6561 20.3844 14.4123 20.3844 14.0465C20.3844 13.6808 20.1382 13.437 19.7688 13.437H15.4613C14.1075 13.437 13 14.5342 13 15.8746V24.4049C13 25.7453 14.1075 26.8418 15.4613 26.8418H24.077C25.4307 26.8418 26.5382 25.7453 26.5382 24.4049V20.1401C26.5389 19.7737 26.2926 19.5305 25.9232 19.5305L25.9232 19.5305Z",
    fill: "#4C4C4C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 1.5,
    stroke: "#C6C2C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.545e4283b9eb7f73f09ec6efcbdecc01.svg";
export { ForwardRef as ReactComponent };